import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TokenHttpInterceptor } from './token.http.interceptor';
import { ErrorService } from '@core/error/error.service';
import { ErrorHttpInterceptor } from '@core/error/error.http.interceptor';


@NgModule({ declarations: [], imports: [], providers: [
        ErrorService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenHttpInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHttpInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class TokenModule {
}
